import { createVNode as e, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NoData2TwotoneStandard.js";
import m from "../components/PfIcon.js";
const t = (o, a) => {
  const r = {
    ...o,
    ...a.attrs
  };
  return e(m, n(r, {
    icon: d
  }), null);
};
t.displayName = "NoData2TwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
